import { render } from "./Persons.vue?vue&type=template&id=63fb5c6b&scoped=true"
import script from "./Persons.vue?vue&type=script&lang=js"
export * from "./Persons.vue?vue&type=script&lang=js"

import "./Persons.vue?vue&type=style&index=0&id=63fb5c6b&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-63fb5c6b"

export default script